// extracted by mini-css-extract-plugin
export default {"amount":"stockForm_amount__wz6r2"};